body = $('body');


body.on('click', '.DL2026_zoneGroup_radio', function () {
    const zoneGroupDL2026Id = $(this).val();
    const customerId = $('#customer').val();
    const partner = $('#partner').val();
    const zoneGroupDL2026getZonesUrl = $(this).data('url');
    let DL2026PackContainer = $('#DL2026_pack_container');

    let firstDL2026Pack = DL2026PackContainer.find('input[type="radio"][value="1"]');
    firstDL2026Pack.prop('checked', true);
    let zoneGroupDL2026IdInt = parseInt(zoneGroupDL2026Id);

    DL2026PackContainer.removeClass('d-none');
    if (zoneGroupDL2026IdInt !== 3) {
        $('.DL2026_price_wrapper').removeClass('d-none');
    } else {
        $('.DL2026_price_wrapper').addClass('d-none');
        $('.DL2026_price_wrapper[data-paid-sessions="1"]').removeClass('d-none');
    }

    $.ajax({
        url: zoneGroupDL2026getZonesUrl,
        type: 'POST',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        data: {
            partner_id: partner,
            customer_id: customerId,
            zone_group_dl_2026_id: zoneGroupDL2026Id
        },
        success: function (response) {
            if (response.status !== 'success') {
                return;
            }

            $.each(response.priceTablesDL2026, function (i, priceTableDL2026) {
                $('.DL2026_price[value="' + priceTableDL2026.paid_sessions + '"]').parent()
                    .parent()
                    .find('.DL2026_price_description')
                    .html(priceTableDL2026.description);
            });

            let options = '<option value="" disabled selected>Selecione uma zona</option>';
            let shouldSelect = '';
            if (response.zonesDL2026.length === 1) {
                shouldSelect = 'selected';
            }

            $.each(response.zonesDL2026, function (index, zone) {
                options += '<option value="' + zone.id + '" data-shoots-min="' + zone.shoots_min + '" data-shoots-max="' + zone.shoots_max + '" ' + shouldSelect + '>' + zone.label + '</option>';
            });

            const zoneDL2026IdEl = $('#zone_dl_2026_id')

            zoneDL2026IdEl.html(options);

            setTimeout(function () {
                if (response.zonesDL2026.length !== 1) {
                    //$('.dl2026_shoots_wrapper').addClass('d-none');
                } else {
                    zoneDL2026IdEl.trigger('change');
                }
            }, 100);
        }
    });
});

body.on('change', '#zone_dl_2026_id', function () {
    const DL2026ShootsWrapper = $('.dl2026_shoots_wrapper');
    const priceEl = $('#price');
    if ($(this).val() === '') {
        priceEl.val('');
        DL2026ShootsWrapper.addClass('d-none');
        return;
    }

    getDL2026Price();

    DL2026ShootsWrapper.removeClass('d-none');

    const shootsMin = $(this).find('option:selected').data('shoots-min');
    const shootsMax = $(this).find('option:selected').data('shoots-max');

    const label = 'Disparos Recomendado : ' + shootsMin + ' - ' + shootsMax;

    $('.shoots_label').html(label);

    let shootsEl = $('#shoots')
    shootsEl.attr('placeholder', label)
    shootsEl.data('min', shootsMin)
    shootsEl.data('max', shootsMax);
});

body.on('change', '.DL2026_price', function () {
    getDL2026Price();
});

function getDL2026Price() {
    const priceInput = $('#price_id');
    const url = priceInput.data('url');
    const method = priceInput.data('method');
    const paidSessions = $('.DL2026_price:checked').val();
    const zoneDL2026Id = $('#zone_dl_2026_id').val();
    const partnerId = $('#partner').val();
    const customerId = $('#customer').val();

    $.ajax({
        url: url,
        type: method,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        data: {
            customer_id: customerId,
            paid_sessions: paidSessions,
            zone_dl_2026_id: zoneDL2026Id,
            partner_id: partnerId
        },
        success: function (data) {
            if (data.status === true || data.status === 'true') {
                priceInput.val(data.price_table_dl_2026_id);
            }
        },
        error: function (err) {
            $('.ajaxFormError').remove();
            if (err.status === 422) { // when status code is 422, it's a validation issue

                $('#success_message').fadeIn().html(err.responseJSON.message);
                // display errors on each form field
                $.each(err.responseJSON.errors, function (i, error) {
                    var el = $(document).find('[name="' + i + '"]');
                    //el.after($('<div class="ajaxFormError mt-1 w-100 toast mb-2 d-flex align-items-center text-white bg-danger border-0" role="alert" aria-live="assertive" aria-atomic="true"><div class="toast-body"><div class="d-flex align-items-center"><i class="fas fa-danger mr-1"></i>' + error[0].replace(i.replace('_', ' '), el.attr('data-title')) + '</div></div></div>'));
                    el.after($('<div class="ajaxFormError alert alert-danger mt-2"><span class="svg-icon svg-icon-danger svg-icon-2hx"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="black"/><rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)" fill="black"/><rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)" fill="black"/></svg></span><div class="d-flex flex-column"><h4 class="mb-1 text-dark">Alerta</h4><span>' + error[0].replace(i.replace('_', ' '), el.attr('data-title')) + '</span></div></div>'));
                    //el.after($('<span class="alert-error">'+error[0].replace(i.replace('_', ' '), el.attr('data-title'))+'</span>'));
                });
            }
        },
        complete: function () {
            $('button[data-kt-indicator="on"]').removeAttr('data-kt-indicator');
        }
    });
}

body.on('change', '.phototype_radio_DL2026', function () {
    $.ajax({
        url: $(this).data('url'),
        type: 'GET',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        success: function (response) {
            $('.phototype_details_table_wrapper').html(response.data.html);
            $('.phototype_details_wrapper').removeClass('d-none');
        }
    });
});
